module.exports = __webpack_public_path__ + "img/98.25ad28f3.jpg";